import React, { Suspense } from 'react';
import { ErrorBoundary } from './error-boundary';
import { LoadingSpinner } from './loading-spinner';

interface LazyComponentProps {
  children: React.ReactNode;
}

const LazyComponent: React.FC<LazyComponentProps> = ({ children }) => {
  return (
    <ErrorBoundary
      onError={(error: Error) => {
        // Log to console for debugging (DA-295)
        console.error('[DA-295] Component failed to load:', error);
        // Sentry logging is handled by ErrorBoundary.componentDidCatch
      }}
    >
      <Suspense
        fallback={
          <div className='flex items-center justify-center h-full'>
            <LoadingSpinner />
          </div>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};

export default LazyComponent;
